export default {
  name: 'splitDetails',
  props: ['splitLineData'],
  watch: {},
  components: {},
  data() {
    return {
      loader: false,
      lineNo: null,
      distribution: {
        text: null,
        value: null
      },
      splitData: [],
      splitFields: [
        {
          key: 'amount',
          class: 'text-center'
        },
        {
          key: 'percent_distribution',
          class: 'text-center'
        },
        {
          key: 'cost_centre',
          class: 'text-center'
        },
        {
          key: 'expense_month',
          class: 'text-center'
        },
        {
          key: 'from_date',
          class: 'text-center'
        },
        {
          key: 'to_date',
          class: 'text-center'
        },
        {
          key: 'concatenated_segments',
          label: 'Code Combination',
          class: 'text-center'
        }
      ],
      splitFinData: [],
      splitFinFields: [
        {
          key: 'oracle_line_description',
          class: 'text-center'
        },
        {
          key: 'period_from',
          label: 'Period From',
          class: 'text-center'
        },
        {
          key: 'period_to',
          label: 'Period To',
          class: 'text-center'
        },
        {
          key: 'days',
          stickyColumn: true,
          class: 'text-center'
        },
        {
          key: 'cost_centre',
          class: 'text-center'
        },
        {
          key: 'cost_centre_amount',
          label: 'Cost Centre Amount',
          class: 'amount'
        },
        {
          key: 'distribution_amount',
          label: 'Distribution Amount',
          class: 'amount'
        },
        {
          key: 'expense_month',
          class: 'text-center'
        },
        {
          key: 'code_combination',
          class: 'text-center'
        },
        {
          key: 'status_code',
          class: 'text-center'
        },
        {
          key: 'status_message',
          class: 'text-center'
        }
      ]
    };
  },
  mounted() {
    if (this.splitLineData) {
      this.getSplitDtlsForCostCenter();
      this.getSplitDtlsForDistribution();
    }
  },
  methods: {
    getSplitDtlsForCostCenter() {
      const payload = {
        vendorInvDtlId: this.splitLineData.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceLoader/getSplitDtlsForCostCenter', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.splitData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getSplitDtlsForDistribution() {
      const payload = {
        vendorInvDtlId: this.splitLineData.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceLoader/getSplitDtlsForDistribution', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.splitFinData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
  }
};
